export const GLOBALS = {
  NAME: 'PROD',
  PRODUCTION: true,
  API: {
    BASE_URL: 'https://balloons-api.digitalemenschen.app',
  },
  TRANSLATION_PATH: './assets/i18n/',
  OCR_PREFIX_TO_DETECT: 'DBR-',
  BALLOON_NR_SIZE: 6,
  DEFAULT_LOCATION: { lat: 47.462520, lng: 7.813823 },  // Sissach: 47.462520, 7.813823,
  DEFAULT_VIDEO_WIDTH: 1920,
  DEFAULT_VIDEO_HEIGHT: 1080,
  OCR_FALLBACK_INPUT: false,
  // ATTENTION: must be the same in Pages/home.component.scss
  IMG_PROCESS_CROP: {
    percentToRemoveLeft: 23.9,
    percentToRemoveTop: 15.4,
    percentToRemoveRight: 17.1,
    percentToRemoveBottom: 11.1,
  },
  MUSIC: {
    withMusic: true,
    error: 'assets/music/balloon-error.wav',
    enter: 'assets/music/balloon-start.wav',
    enterDuration: 500,
    inProgress: 'assets/music/balloon-progress.wav',
    finish: 'assets/music/balloon-success.wav',
  },
};

